import React from 'react';
import { useThemeClasses } from '../../hooks/useThemeClasses';

export default function AdminEmpty({ icon: Icon, title, subtitle }) {
  const tc = useThemeClasses();

  return (
    <div className="px-6 py-12 text-center">
      {Icon ? <Icon className={`w-10 h-10 mx-auto mb-3 ${tc.modoOscuro ? 'text-gray-600' : 'text-gray-300'}`} /> : null}
      <p className={`text-sm font-medium ${tc.textPri}`}>{title}</p>
      {subtitle ? <p className={`text-xs mt-1 ${tc.textMuted}`}>{subtitle}</p> : null}
    </div>
  );
}
